export function objectsMigrationHref(href: string): string {
  return href.replace('/journeys/objects', '/objects');
}

export function objectsLegacyHref(href: string): string {
  return href.replace('/objects', '/journeys/objects');
}

export function objectTypeRedirectHref(baseHref: string, search: string, hash: string): string {
  const normalizedHash = hash === '' || hash.startsWith('#') ? hash : `#${hash}`;
  return `${baseHref}${search}${normalizedHash}`;
}
